<template>
  <div>
    <div class="step">
      <div class="review-success card">
        <div class="review-success__title">
          {{ t('review.form.successTitle') }}
        </div>
        <div class="review-success__subtitle">
          {{ t('review.form.successText') }}
        </div>

        <div class="review-success__coupon" :class="{ copied: isCodeCopied }">
          <div ref="discountCode" class="review-success__code">KONBACK15</div>
          <div class="review-success__copy" @click="copyCode">
            {{
              isCodeCopied
                ? t('review.form.copyCodeSuccess')
                : t('review.form.copyCode')
            }}
          </div>
        </div>

        <Button
          color="primary"
          class="w-full flex text-center justify-center"
          :link="localePath('/')"
        >
          {{ t('review.form.backButton') }}
        </Button>
      </div>
    </div>
    <div class="line line--top">
      <img src="/reviews/line-bottom.gif" alt="" />
    </div>
    <div class="line line--bottom">
      <img src="/reviews/line-top.gif" alt="" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const { t } = useI18n()
const $localePath = useLocalePath()
const localePath = $localePath
const discountCode = ref<HTMLElement | null>(null)
const isCodeCopied = ref(false)

const copyCode = () => {
  if (discountCode.value) {
    navigator.clipboard.writeText(discountCode.value.textContent || '')
    isCodeCopied.value = true
    setTimeout(() => {
      isCodeCopied.value = false
    }, 1000)
  }
}
</script>

<style scoped lang="postcss">
.step {
  @apply max-w-[600px] m-auto relative z-1;
  animation: blockFadeInUp 0.5s ease-in-out forwards;
}

@keyframes blockFadeInUp {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.card {
  @apply bg-white p-4 rounded-lg;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.review-success {
  &__title {
    @apply text-h3 text-center font-semibold mb-8 text-teal-900;
  }

  &__subtitle {
    @apply text-lg font-medium mb-4 text-teal-900;
  }

  &__coupon {
    box-shadow:
      0 0 0 1px rgba(2, 44, 34, 0.13),
      0 1px 2px 0 rgba(2, 44, 34, 0.08);
    background: #fff;
    @apply w-full h-[88px] md:h-[44px] py-1 pr-1 pl-1 md:pl-5 rounded-lg md:flex md:items-center mb-4 ease-in-out duration-300;

    &.copied {
      @apply bg-lime-50;
    }
  }

  &__code {
    @apply text-sm flex h-[40px] w-full md:w-auto justify-center items-center text-center md:text-left;
    color: #646a69;
  }

  &__copy {
    @apply h-[40px] md:h-full min-w-[113px] px-5 rounded-lg border flex items-center text-center justify-center border-teal-900;
    @apply text-teal-900 font-semibold text-sm cursor-pointer ml-auto ease-in-out duration-300;

    &:hover {
      @apply bg-teal-900 text-white;
    }
  }
}

.line {
  pointer-events: none;
  img {
    @apply fixed;
  }

  &--top img {
    @apply left-0 bottom-0 max-w-[160px] md:max-w-[600px];
  }

  &--bottom img {
    @apply right-0 bottom-0 max-w-[160px] md:max-w-[600px];
  }
}
</style>
